"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function allAgeGroups(state, getters) {
    var ageGroup = {
        A: 0,
        J: 0,
        C: 0
    };
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        var cabinAgeGroup = getters[cabin + '/persons/asAgeGroups'];
        ageGroup.A = ageGroup.A + cabinAgeGroup.A;
        ageGroup.J = ageGroup.J + cabinAgeGroup.J;
        ageGroup.C = ageGroup.C + cabinAgeGroup.C;
    }
    return ageGroup;
}
exports.default = allAgeGroups;
//# sourceMappingURL=allAgeGroups.js.map